import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { US_STATES } from "../../constants/global-constants";

const InspectorLicense = ({
  formData,
  handleInputChange,
  validationErrors = {},
}) => {
  return (
    <>
      <h2 className="mb-3">Inspector License</h2>
      <Row className="g-3">
        <Col xs={12}>
          <Form.Group>
            <Form.Label>License Number</Form.Label>
            <Form.Control
              type="text"
              name="license_number"
              value={formData.license_number}
              onChange={handleInputChange}
              isInvalid={!!validationErrors.license_number}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.license_number}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>State Issued</Form.Label>
            <Form.Select
              name="state_issued"
              value={formData.state_issued}
              onChange={handleInputChange}
              isInvalid={!!validationErrors.state_issued}
            >
              <option value="">Select State</option>
              {US_STATES.map((state) => (
                <option key={state.value} value={state.value}>
                  {state.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {validationErrors.state_issued}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Expiry Date</Form.Label>
            <Form.Control
              type="date"
              name="expiry_date"
              value={formData.expiry_date || ""}
              onChange={handleInputChange}
              isInvalid={!!validationErrors.expiry_date}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.expiry_date}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs={12}>
          <Form.Group>
            <Form.Label>Note</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="note"
              value={formData.note}
              onChange={handleInputChange}
              isInvalid={!!validationErrors.note}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.note}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default InspectorLicense;
